import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Layout from '../Layout';
import Seo from '../component/Seo';
import { langPathSuffix } from '../lang-utils';
import Gallery from '../component/GallerySection';

const SEO = {
  lt: {
    title: 'Darbų galerija – tralo paslaugos Lietuvoje | Geltonas Traliukas',
    description: 'Mūsų darbų galerija: automobilių pervežimas traliuku, pagalba kelyje, avariniai atvejai Kaune ir visoje Lietuvoje.',
    h1: 'Darbų galerija',
    intro: 'Nuotraukose – mūsų realūs darbai: automobilių pervežimas traliuku, pagalba avarijos atveju, gedimo situacijos kelyje. Visa veikla – Kaune ir visoje Lietuvoje.',
    crossTitle: 'Daugiau informacijos',
    crossService: 'Mūsų paslaugos',
    crossFaq: 'DUK',
    crossContact: 'Susisiekti'
  },
  en: {
    title: 'Work gallery – tow truck services in Lithuania | Geltonas Traliukas',
    description: 'Photo gallery of our work: vehicle transport, roadside assistance, emergency cases in Kaunas and across Lithuania.',
    h1: 'Work gallery',
    intro: 'The photos show our real work: vehicle transport by tow truck, accident assistance, breakdowns on the road. All operations – in Kaunas and throughout Lithuania.',
    crossTitle: 'More information',
    crossService: 'Our services',
    crossFaq: 'FAQ',
    crossContact: 'Contact us'
  },
  ru: {
    title: 'Галерея работ – услуги эвакуатора в Литве | Geltonas Traliukas',
    description: 'Фотогалерея наших работ: перевозка автомобилей эвакуатором, помощь на дороге, аварийные случаи в Каунасе и по всей Литве.',
    h1: 'Галерея работ',
    intro: 'На фотографиях — наши реальные работы: перевозка автомобилей эвакуатором, помощь при ДТП, поломки на дороге. Работаем в Каунасе и по всей Литве.',
    crossTitle: 'Больше информации',
    crossService: 'Наши услуги',
    crossFaq: 'FAQ',
    crossContact: 'Связаться'
  }
};

function GalerijaPage({ lang = 'lt' }) {
  const t = SEO[lang] || SEO.lt;
  return (
    <Layout
      lang={lang}
      renderChildren={({ strings, pageWidth, onTop }) => {
        return (
          <>
            <Seo path="/galerija/" lang={lang} title={t.title} description={t.description} pageName={strings.navbar.gallery} />
            <Container className="section-padding">
              <div className="text-center">
                <h1 className="section-title">{t.h1}</h1>
                <div className="section-underline" />
              </div>
              <p className="text-justify page-intro">{t.intro}</p>
            </Container>
            <Gallery strings={strings} onTop={onTop} pageWidth={pageWidth} section="light" hideTitle />
            <Container className="section-padding">
              <h2 className="text-center">{t.crossTitle}</h2>
              <ul className="cross-links">
                <li><Link to={`/paslaugos/${langPathSuffix(lang)}`}>{t.crossService}</Link></li>
                <li><Link to={`/duk/${langPathSuffix(lang)}`}>{t.crossFaq}</Link></li>
                <li><Link to={`/kontaktai/${langPathSuffix(lang)}`}>{t.crossContact}</Link></li>
              </ul>
            </Container>
          </>
        );
      }}
    />
  );
}

export default GalerijaPage;
